import { DistrictDropdownTwoWayComponent } from 'src/app/component/common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { PARTYROLE, Region } from '../../../model/region.model';
import { County } from '../../../model/county';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Router } from '@angular/router';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';

import { BaseLocalStorageService } from 'src/app/service/base-local-storage.service';
import { Observable } from 'rxjs/internal/Observable';
import { timer } from 'rxjs';

import { OrganizationService } from '../../common-components/organizations/service/organization.service';
import { ORGANIZATION, School } from 'src/app/model/school.model';
import { UserProfileService } from '../../user-profile/service/user-profile.service';
import { HelperService } from 'src/app/service/helper.service';
import { User } from '../../auth/model/user.model';
import { RegionDropdownTwoWayComponent } from '../../common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';
import { CountyDropdownTwoWayComponent } from '../../common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';

@Component({
    selector: 'app-search-location-layer',
    templateUrl: './search-location-layer.component.html',
    styleUrls: ['./search-location-layer.component.css']
})
export class SearchLocationLayerComponent implements OnInit {
    @ViewChild(DistrictDropdownTwoWayComponent) child!: DistrictDropdownTwoWayComponent;
    @ViewChild(RegionDropdownTwoWayComponent) child2!: RegionDropdownTwoWayComponent;
    //ElementRef<RegionNoloadDropdownComponent>;
    @ViewChild(CountyDropdownTwoWayComponent) child3!: CountyDropdownTwoWayComponent;

    @Input('showDistrictDropdown') showDistrictDropdown: boolean = true;

    @Output() eventEmitterDistrictcode = new EventEmitter<SchoolDistrict[]>();
    @Output() eventEmitterCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterRegioncode = new EventEmitter<Region[]>();

    formCtrl = new UntypedFormControl();
    myForm = new UntypedFormArray([new UntypedFormControl('', Validators.required)]);
    selectLabel1: string = 'Select Region(s)';
    selectLabel2: string = 'Select County(s)';
    selectLabel3: string = 'Select School District(s)';
    isLoading = true; // this one is for initial data load
    isLoadingRegions = true;
    isLoadingCounties = true;
    isLoadingDistricts = true;
    isLoadingResults = false; // this one is strictly for loading search results
    school: School;
    region!: Region;
    regions: Region[] = [];
    district!: SchoolDistrict;
    selectedSchoolDistrictId: number;
    selectedSchoolDistrictIds: number[];
    selectedCountyIds: number[];
    selectedRegionIds: number[];
    districts = [];
    promises: Array<any> = [];
    partyId: any = [{}];
    organizationId!: number;
    myOrganization!: ORGANIZATION;
    partyIdNum!: number;
    user: User = {};
    partyRoles: PARTYROLE[] = [];
    resetFieldRegions: boolean = false;
    resetFieldCounties: boolean = false;
    resetFieldDistricts: boolean = false;
    baseLocalStorageService: any;
    localStorageInfo$: Observable<any> = new Observable();
    checkedList: boolean[] = [];
    organizationService!: any;
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];

    constructor(
        private router: Router,
        private store: Store<AppState>,
        _baseLocalStorageService: BaseLocalStorageService,
        private _organizationService: OrganizationService,
        private userProfileService: UserProfileService,
        private helperService: HelperService
    ) {
        this.region = new Region();
        // prep localStorage
        this.baseLocalStorageService = _baseLocalStorageService;
        this.localStorageInfo$ = _baseLocalStorageService.myData$;

        this.organizationService = _organizationService;
    }

    ngOnInit(): void {
        // const timeSpinnerOut = setTimeout(() => {
        //     this.isLoading = false;
        // }, 7000);
        /*
        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            this.getPartyRoles();
            this.getRegionsByPartyId();
        });
*/
        // load party data
        /* this.organizationId = 3; // hardcode this for testing only

        this.organizationService.show(this.organizationId)
            .subscribe({
                next: (res: any) => {

                    this.myOrganization = res.organization;
                   // console.log("organization is: " + Object.entries(this.myOrganization));
                   // console.log("party ids are: " + this.myOrganization.PARTIES_ID)
                    this.partyId = this.myOrganization.PARTIES_ID;

                    this.partyIdNum = parseInt(this.partyId);                    

                   // console.log("inbound organization id1 is: " + this.organizationId);

                   // console.log("my organization: " + this.myOrganization.PARTIES_ID);

                },
                error: (err: any) => {
                    alert("Error while fetching the organization records");
                    console.log("error while getting organization data")
                }
            });
        */
        this.fnSetInitialData();
    }

    regionsSelected(regions: Region[]) {
        //	if (!this.isLoading)
        //	{
        console.log('region emit being called');
        this.eventEmitterRegioncode.emit(regions);
        //	}
        this.fnCheckIsLoading();
    }

    districtsSelected(districts: SchoolDistrict[]) {
        if (!this.isLoading) {
            console.log('districts emit being called');

            this.eventEmitterDistrictcode.emit(districts);
        }
        this.fnCheckIsLoading();
    }

    countiesSelected(counties: County[]) {
        //if (!this.isLoading)
        //	{

        console.log('counties emit being called');

        this.eventEmitterCountycode.emit(counties);
        //	}
        this.fnCheckIsLoading();
    }

    fnCheckIsLoading() {
        if (!this.isLoadingCounties && !this.isLoadingRegions && !this.isLoadingDistricts) {
            console.log('setting isLoading to false');
            // run this once more after all have loaded to ensure it displays
            this.child.select(this.child.selectedSchoolDistrictIds);

            this.isLoading = false;

            /*	const dropdownElement = this.child2.nativeElement;
			console.log(dropdownElement?.selectedRegionIds)
			try
			{
				dropdownElement.select(dropdownElement?.selectedRegionIds);
			}
			catch (Err)
			{
				console.log("Error selecting dropdown regionids: " + Err)
			}*/
        }
    }

    fnResetLocations() {
        let blankNumArray: number[] = [];
        let blankRegionsObj: Region[] = [];
        let blankCountiesObj: County[] = [];
        let blankDistrictsObj: SchoolDistrict[] = [];
        console.log('called fnResetLocations in searchlocationlayers');
        setTimeout(() => {
            /*   this.child2.selectedRegionIds = [];
            this.child2.select(blankNumArray);
            this.regionsSelected(blankRegionsObj);
            this.child2.reset = true; */
            this.child3.selectedCountyIds = [];
            this.child3.reset = true;
            this.child3.select(blankNumArray);

            this.child2.selectedRegionIds = [];
            this.child2.reset = true;
            this.child2.select(blankRegionsObj);

            this.countiesSelected(blankCountiesObj);
            this.child.select(blankNumArray);
            this.child.reset = true;
            this.districtsSelected(blankDistrictsObj);
        });

        try {
            this.checkedList = this.baseLocalStorageService?.getInfo('lastCheckedList');

            if (this.checkedList) {
                this.baseLocalStorageService.removeItem('lastCheckedList');
            }
        } catch (Err) {
            console.log('Error, but likely no localStorage yet for checkedLists:' + Err);
        }
    }

    reset() {
        //This is optional code To reset the value after
        console.log('reset method called in searchlocationlayer');
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetFieldRegions = !this.resetFieldRegions;
            this.resetFieldCounties = !this.resetFieldCounties;
            this.resetFieldDistricts = !this.resetFieldDistricts;
        });
        this.districts = [];
        this.child.selectedSchoolDistrictIds = [];
    }

    fnSetInitialData() {
        /*if ((!this.isLoading) && (!this.isLoadingResults))
		{
       		 this.district = this.districts[0];
		}*/
    }

    /*
    getPartyRoles() {
        console.log("getting party roles for user:" + Object.entries(this.user))
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log("got party roles:" + res.partyRoles)
            }
        });
    }

    getRegionsByPartyId() {
        //console.log("Setting regions by party id:")
        //console.log(this.user!.PERSON!.PARTy!.ID!)
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                this.regions = res.regions;
                //console.log("regions now:");
                //console.log(Object.entries(this.regions[0]))

                this.region = this.regions[3];
                console.log("Setting regions in searchlocationlayer to:" + Object.entries(this.regions))
                // set region/county/district data+ Object.entries(thisRegion))
                this.helperService.setSelectedRegionObject(this.regions);
                this.helperService.selectedRegions$.forEach(x => console.log(x));

            }
        });
    }
*/
}
